<app-sidebar [user]="user" (mode)="modeChange($event)" (menuItemClicked)="toggleMenu.set(false)" [ngClass]="{sideOpened: toggleMenu()}" class="z-[99] fixed sm:static"></app-sidebar>

<div class="main-panel flex flex-col flex-1 overflow-auto">

  <app-top-bar [user]="user" (toggleMenuChange)="toggleMenu.set($event)" [toggleMenu]="toggleMenu()"></app-top-bar>

  <router-outlet></router-outlet>

</div>


<div class="right-panel fixed right-0 top-0 h-screen">
  <app-notification-panel></app-notification-panel>
</div>

@if (notifBarOpened) {
  <div class="back-drop" (click)="toggle()"></div>
}
